export default __webpack_public_path__ + "static/media/Canach Breeches.085ab7e1.jpg";